<template>
  <div class="personnel-add">
    <FormInfo :formData="formData" :isEdit="false"></FormInfo>
  </div>
</template>

<script>
import FormInfo from "./personnel-form";

export default {
  data() {
    return {
      formData: null
    };
  },
  created() {
    setTimeout(() => {
      this.formData = {
        name: "",
        mobile: "",
        head_img: "",
        role_id: "",
        desp: "",
        state: true
      };
    });
  },
  components: {
    FormInfo
  },
  methods: {}
};
</script>

<style lang="less" scoped>
</style>